<div class="header">
  <div class="color-navy-900 text-size_xl font-semibold">Company Name</div>
  <div class="flex gap-2 items-center">
    <app-simple-button (click)="openContactsSidebar()">Add Contact</app-simple-button>
    <app-simple-button (click)="openInvitationsSidebar()">Send Invite</app-simple-button>
  </div>
</div>
<app-loading-bar [hidden]="!(loading() && invitationGroups()?.length !== 0)"></app-loading-bar>

<section class="content">
  @for (invitationGroup of invitationGroups(); track invitationGroup.id; let index = $index) {
    <app-expansion-panel-v2 [expanded]="isExpanded()[invitationGroup.id]" #panel>
      <div header-row (click)="togglePanelExpansion(invitationGroup.id)" class="contacts-row company">
        <div class="initials">{{ invitationGroup.initials }}</div>
        <div>
          <div class="font-semibold text-navy-900 text-size_xxl">{{ invitationGroup.name }}</div>
        </div>
        <div
          class="icon icon-participants-circle-bg"
          [ngClass]="{
            'text-navy-900': panel.isExpanded
          }"
        ></div>
        <div class="status">{{ invitationGroup.invitations.length }} invited</div>
      </div>

      <div content-row>
        @for (invitation of invitationGroup.invitations; track $index) {
          <div class="contacts-row contact">
            <div class="initials">{{ invitation?.initials }}</div>
            <div>
              <div class="font-bold text-size_xl text-navy-900">
                {{ invitation?.name }}
              </div>
              <div class="font-normal text-size_xl text-navy-900">{{ invitation?.title }}</div>
            </div>
            <app-options-list-simple
              [disabled]="invitation?.status === 'accepted'"
              [actions]="invitationOptions(invitation)"
              (optionSelected)="onInvitationOptionSelected($event, invitation)"
            ></app-options-list-simple>
            <div (click)="sendMessageTo(invitation)" class="icon icon-messages hover:text-navy-700"></div>

            <div class="status" [ngStyle]="{ 'background-color': INVITATION_STATUS_COLORS[invitation?.status] }">
              {{ invitation?.status }}
            </div>
          </div>
        } @empty {
          <div class="contacts-row contact no-contacts">No contacts in this company yet.</div>
        }
      </div>
    </app-expansion-panel-v2>
  } @empty {
    @if (loading()) {
      <app-page-loading></app-page-loading>
    } @else {
      <app-splash-screen title="There are no invites yet." subTitle="Get started by adding a new invite.">
        <app-simple-button size="large" (click)="openInvitationsSidebar()">Send Invite</app-simple-button>
      </app-splash-screen>
    }
  }
</section>
